(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOpportunityStatusDialogController', CrmOpportunityStatusDialogController);

    CrmOpportunityStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CrmOpportunityStatus'];

    function CrmOpportunityStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmOpportunityStatus) {
        var vm = this;

        vm.crmOpportunityStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.crmOpportunityStatus.id !== null) {
                CrmOpportunityStatus.update(vm.crmOpportunityStatus, onSaveSuccess, onSaveError);
            } else {
                CrmOpportunityStatus.save(vm.crmOpportunityStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:crmOpportunityStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
